import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { getLoginError, getUser, hasError } from '../../selectors/common';
import ErrorModal from '../../components/Modals/ErrorModal';
import { MODALS, PAGES } from '../../constants';
import validateFields from '../../utils/validation';
import { aLogin } from '../../reducers';
import { aSetOpenModal } from '../../reducers/common';

const mapToProps = (state) => ({
  loginError: getLoginError(state),
  hasError: hasError(state),
  user: getUser(state),
});

const actionsToProps = (dispatch) => ({
  login: (payload) => dispatch(aLogin(payload)),
  setOpenModal: (payload) => dispatch(aSetOpenModal(payload)),
});


const Login = (props) => {
  const navigate = useNavigate();

  useEffect(() => {
    if (props.user) {
      navigate(PAGES.HOME);
    }
  // eslint-disable-next-line
  }, []);

  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [errorMgs, setErrorMgs] = useState({});
  const [showPassword, setShowPassword] = useState(false);
  const [loginInProgress, setLoginInProgress] = useState(false);

  const changeUsername = (e) => {
    setUsername(e.target.value);
    setErrorMgs({});
  };

  const changePassword = (e) => {
    setPassword(e.target.value);
    setErrorMgs({});
  };

  const login = () => {
    if (!loginInProgress || props.loginError) {
      const validationParams = [
        {
          label: 'Username', fieldName: 'username', value: username, rules: ['mandatory'],
        },
        {
          label: 'Password',
          fieldName: 'password',
          value: password,
          rules: ['mandatory'],
        },
      ];
      validateFields(validationParams)
        .then(() => {
          props.login({
            username,
            password,
            navigate,
          });
          setLoginInProgress(true);
        }).catch((er) => {
          setErrorMgs(er);
        });
    }
  };

  const togglePasswordView = () => {
    setShowPassword(!showPassword);
  };

  return (
    props.hasError ? (
      <ErrorModal
        message={props.hasError}
        setOpenModal={props.setOpenModal}
        additionalMessage="Please refresh application"
        modal={MODALS.GENERAL_ERROR}
      />
    )
      : (
        <div className="login">
          <div className="login__wrap container">
            <div className="login__img" />
            <div className="row no-gutters">
              <div className="col-sm-4">
                <div className="login__panel text-center">
                  <div className="login__panel-wrap">
                    <div className="logo" />
                    <div className="login__panel-title m-t-15">
                      <span>Zoom</span>
                      backoffice
                    </div>
                    <div className="login__panel-txt m-t-15 m-b-15">Backoffice management system</div>
                    <div className="login__panel-copyright text-left">© 2020. All Rights Reserved | Version 2.0</div>
                  </div>
                </div>
              </div>
              <div className="col-sm-8">
                <div className="login__form">
                  <div className="login__form-wrap">
                    <div className="login__form-title">
                      Log into
                      {' '}
                      <span>Zoom Backoffice</span>
                    </div>
                    <div className="login__form-txt m-t-15">Enter your login details</div>
                    <div className="form form--login">
                      <div className="form__input-wrap m-t-30">
                        {(props.loginError && (
                          <div className="form__msg form__msg--error m-b-20">
                            {props.loginError}
                          </div>
                        ))}
                        <label className="form__label" htmlFor="email">Username</label>
                        <div className="form__input-grp">
                          <span className="form-icon email" />
                          <input
                            className="form__input form__input--icon form__input--error"
                            type="email"
                            id="email"
                            placeholder="Enter your username"
                            onChange={changeUsername}
                            value={username}
                          />
                        </div>
                        {errorMgs.username}
                      </div>
                      <div className="form__input-wrap m-t-30">
                        <label className="form__label" htmlFor="password">Password</label>
                        <div className="form__input-grp">
                          <span className="form-icon lock" />
                          {password.length > 0
                            && (
                              <span
                                className={`password-toggle 
                                ${!showPassword && 'show'}`}
                                onClick={togglePasswordView}
                              />
                            )}
                          <input
                            className="form__input form__input--icon form__input--error"
                            type={showPassword ? 'text' : 'password'}
                            id="password"
                            placeholder="Enter your password"
                            onChange={changePassword}
                            value={password}
                          />
                        </div>
                        {errorMgs.password}

                      </div>
                      <div className="form__btn m-t-30" onClick={login} id="signIn_LoginPage">Sign in</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )
  );
};

export default connect(mapToProps, actionsToProps)(Login);
